import React, { Component, } from 'react'
import config from '../../resource/config.js'

const cancelApi = config.apiBaseUrl + 'apbe/cancelrequest'


class cancelModal extends Component {
    constructor(props) {
        super(props)
        this.handleCancel = this.handleCancel.bind(this)
        this.state = { requestId: '', ErrorMsg: '' }
        this.modalId = `${this.props.triggerId.replace('Trigger', '')}Container`
    }

    componentDidMount() {
        if (typeof _satellite !== 'undefined')
            window._satellite.track('cbTrack.viewInDom')

        const triggerElement = document.getElementById(this.props.triggerId)
        if (triggerElement) {
            window.cb.apricot.CBModal.init({
                elem: triggerElement,
                targetElem: this.modalId,
            })
        }
    }

    handleCancel() {
        const requestParams = {
            reqId: this.props.PassDataItems.REQUEST_ID,
            cognitoId: this.props.PassDataItems.COGNITO_ID,
        }
        fetch(cancelApi, {
            method: 'POST',
            dataType: 'jsonp',
            headers: this.props.apiAuthHeaders,
            body: JSON.stringify(requestParams)
        })
            .then(res => res.json())
            .then(
                success => {
                    console.log("Cancel response ", success)
                    const msg = success
                    if (msg === `Request ${this.props.PassDataItems.REQUEST_ID} has been canceled successfully!`) {
                        window.location.reload()
                    } else {
                        this.setState({ ErrorMsg: msg })
                    }
                })
            .catch(error => console.error('Error:', error))
    }

    render() {
        return (
            <div className="cancelModal">
                <div id={this.modalId} className="cb-modal" aria-hidden="true">
                    <div className="cb-modal-overlay" tabIndex="-1" data-cb-modal-close>
                        <div className="cb-modal-container" role="dialog" aria-modal="true"
                             aria-labelledby={`${this.modalId}Title`}>
                            <div className="cb-modal-header cb-modal-has-close">
                                <h2 className="cb-modal-title" id={`${this.modalId}Title`}>Confirm
                                    Cancellation</h2>
                                <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale cb-btn-close"
                                        aria-describedby={`${this.modalId}Title`} data-cb-modal-close>
                                    <span className="cb-glyph cb-x-mark" aria-hidden="true"></span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </div>
                            <div className="cb-modal-content">
                                <p>Are you sure you want to cancel this request?</p>
                                <p>Click <strong>Yes</strong> to cancel your request. You can then create a new request.
                                    Click <strong>No</strong> to return to your request.</p>
                            </div>
                            <div className="cb-modal-footer">
                                <div className="cb-btn-row">
                                    <button type="button" className="btn btn-naked btn-sm" data-cb-modal-close>NO
                                    </button>
                                    <button type="button" className="btn btn-primary btn-sm cb-margin-left-16"
                                            data-cb-modal-close
                                            onClick={this.handleCancel}>YES
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default cancelModal
